import { Type } from "class-transformer";
import { Absence } from "./absences";
import { Employment } from "./employments";
import { AbstractJSONModel } from "./master-model";
import { Pool } from "./pools";

export interface IWorkHourPoolStatus {
  work_hour_pools: Pool[];
  absences: Absence[];
  employments: Employment[];
}

export class WorkHourPoolStatus extends AbstractJSONModel implements IWorkHourPoolStatus {
  @Type(() => Pool)
    work_hour_pools: Pool[] = [];
  @Type(() => Absence)
    absences: Absence[] = [];
  @Type(() => Employment)
    employments: Employment[] = [];
}
